import { ApolloProvider } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";
import { createBrowserHistory } from "history";
import React, { Suspense, lazy } from "react";
import { Route, Router, Switch } from "react-router-dom";

import { apolloClient } from "./modules/core/api";
import Application from "./modules/core/components/Application";
import ErrorBoundary from "./modules/core/components/ErrorBoundary";
import DashboardPage from "./modules/dashboard/components/DashboardPage";
import AuthProvider from "./modules/core/components/AuthProvider";

import "./App.css";
const CoreRoutes = lazy(() => import("./modules/core/routes"));
const LoginRoutes = lazy(() => import("./modules/login/routes"));
const HomeRoutes = lazy(() => import("./modules/home/routes"));
const AufstellungRoutes = lazy(() => import("./modules/aufstellung/routes"));
const AkteRoutes = lazy(() => import("./modules/akte/routes"));
const PersonRoutes = lazy(() => import("./modules/person/routes"));

const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });

const App: React.FunctionComponent = () => (
  <ErrorBoundary>
    <AuthProvider>
      <Router history={history}>
        <ApolloProvider client={apolloClient}>
          <Application>
            <Switch>
              <Suspense fallback={<LinearProgress />}>
                <CoreRoutes />
                <LoginRoutes />
                <Route
                  key="dashboard"
                  path="/dashboard"
                  render={() => (
                    <DashboardPage>
                      <Suspense fallback={<LinearProgress />}>
                        <HomeRoutes />
                        <AkteRoutes />
                        <AufstellungRoutes />
                        <PersonRoutes />
                      </Suspense>
                    </DashboardPage>
                  )}
                />
              </Suspense>
            </Switch>
          </Application>
        </ApolloProvider>
      </Router>
    </AuthProvider>
  </ErrorBoundary>
);

export default App;
